// extracted by mini-css-extract-plugin
export default {"new_limit_wrap":"LimitModal_new_limit_wrap__KNgKP","textfield":"LimitModal_textfield__k5N+j","close":"LimitModal_close__P2HjI"};